/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useContext, useEffect, useState } from 'react'

import { PAGE_TITLE } from '../../Configuration'
import usePageTitle from '../../hooks/use-page-title'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { optionsTypes } from '../../utils/controls/select-options-data'
import AdminView from './admin-view'
import CustomerView from './customer-view'
import './home.css'

type DashboardView = 'admin' | 'customer' | 'loading'

const Home = () => {
  usePageTitle(PAGE_TITLE.HOME) //sets page title
  const {categories, components, isLoading, majcoms, sections } = useContext(MetadataContext)
  const {
    isCPOwner,
    isCSS,
    isHigherMPF,
    isLeadership,
    isMAJCOMOwner,
    isMPF,
    isMPFOwner,
    roleIsLoading,
  } = useContext(RoleContext)
  const { currentPage, setCurrentPage, setPreviousPage } =
    useContext(PreviousPageContext)

  const [view, setView] = useState<DashboardView>('loading')
  const [ComponentOptions, setComponentOptions] = useState<optionsTypes[]>([])
  const [MajcomOptions, setMajcomOptions] = useState<optionsTypes[]>([])
  const [CategoryOptions, setCategoryOptions] = useState<optionsTypes[]>([])
  const [SectionOptions, setSectionOptions] = useState<optionsTypes[]>([])

  useEffect(() => {
    if (
      !isLoading &&
      categories.length > 0 &&
      components.length > 0 &&
      majcoms.length > 0 &&
      sections.length > 0
    ) {
      setComponentOptions(ComponentOptions)
      setMajcomOptions(MajcomOptions)
      setCategoryOptions(CategoryOptions)
      setSectionOptions(SectionOptions)
    }
  }, [categories, components, majcoms, sections])

  useEffect(() => {
    if (!(roleIsLoading || isLoading)){
      setView(
      isCSS ||
        isMPF ||
        isHigherMPF ||
        isCPOwner ||
        isMPFOwner ||
        isMAJCOMOwner ||
        isLeadership
        ? 'admin'
        : 'customer'
    )}
  }, [roleIsLoading, isLoading])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== '/') {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Previous page
      setCurrentPage('/') // Current Page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  return (
    <div>
      {!(isLoading || roleIsLoading || currentPage !== '/') && (
        <>
          {view === 'customer' && (
            <CustomerView CategoryOptions={CategoryOptions} SectionOptions={SectionOptions} />
          )}
          {view === 'admin' && (
            <AdminView
              CategoryOptions={CategoryOptions}
              ComponentOptions={ComponentOptions}
              MajcomOptions={MajcomOptions}
              SectionOptions={SectionOptions}
            />
          )}
        </>
      )}
    </div>
  )
}
export default Home
